module.exports = __webpack_public_path__ + "static/img/banner02.23aca97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner02.jpg
// module id = mydt
// module chunks = 0